import Vue from 'vue'
import Router from 'vue-router'
import store from './store';

Vue.use(Router)
// console.log(window.location.href);
// let indexComponent = "";

//  this.$store.state.store.is_project == "0" ? indexComponent = "@/pages/index/Index.vue" : indexComponent = "@/pages/indexproject/IndexP.vue"

let router = new Router({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes: [

		/* 用户端 */
		//修改密码
		{
			path: '/changepassword',
			name: 'changepassword',
			component: () => import('@/pages/changepassword/ChangePassword.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//忘记密码
		{
			path: '/forgetpassword',
			name: 'forgetpassword',
			component: () => import('@/pages/forgetpassword/ForgetPassWord.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//测试页面
		{
			path: '/test',
			name: 'test',
			component: () => import('@/pages/Test/Test.vue')
		},
		//课程云首页
		{
			path: '/',
			name: 'index',
			component: () => import('@/pages/index/Index.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//项目式店铺首页
		// {
		//   path: '/indexproject',
		//   name: 'indexproject',
		//   component: () => import('@/pages/indexproject/IndexProject.vue'),
		//   meta: {
		//     showFooter: true,
		//     showHeader: true
		//   }
		// },
		//购物车页面
		{
			path: '/shoppingcart',
			name: 'shoppingcart',
			component: () => import('@/pages/shoppingcart/ShoppingCart.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//下单页面
		{
			path: '/pay',
			name: 'pay',
			component: () => import('@/pages/pay/Pay.vue'),
			meta: {
				showFooter: false,
				showHeader: true
			}
		},
		//课程详情页面
		{
			path: '/classdetails',
			name: 'classdetails',
			component: () => import('@/pages/classdetails/ClassDetails.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//课程搜索页面
		{
			path: '/classsearch',
			name: 'classsearch',
			component: () => import('@/pages/classsearch/ClassSearch.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		// 课程学习页面
		{
			path: '/classstudy',
			name: 'classstudy',
			component: () => import('@/pages/classstudy/ClassStudy.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//我的历史订单页面
		{
			path: '/myorder',
			name: 'myorder',
			component: () => import('@/pages/myorder/MyOrder.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//订单详情页面
		{
			path: '/myorderdetails',
			name: 'myorderdetails',
			component: () => import('@/pages/myorderdetails/MyOrderDetails.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		// 个人中心页面
		{
			path: '/personalcenter',
			name: 'personalcenter',
			component: () => import('@/pages/personalcenter/PersonalCenter.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},

		//支付中心(选择支付方式)
		{
			path: '/rechargeBalance',
			name: 'rechargeBalance',
			component: () => import('@/pages/recharge-balance/recharge-balance.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//畅和充值中心
		{
			path: '/paycenter',
			name: 'paycenter',
			component: () => import('@/pages/paycenter/PayCenter.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		// 考试测验
		{
			path: '/classexam',
			name: 'classexam',
			component: () => import('@/pages/classexam/ClassExam.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		// 考试答案
		{
			path: '/classexamanswer',
			name: 'classexamanswer',
			component: () => import('@/pages/classexamanswer/ClassExamAnswer.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		// 底部组件
		{
			path: '/tpfooter',
			name: 'tpfooter',
			component: () => import('@/pages/tpfooter/TpFooter.vue')
		},
		//头部导航组件
		{
			path: '/tpheader',
			name: 'tpheader',
			component: () => import('@/pages/tpheader/TpHeader.vue')
		},
		//视频学习页面
		{
			path: '/learnvideo',
			name: 'learnvideo',
			component: () => import('@/pages/learnvideo/LearnVideo.vue'),
			meta: {
				showFooter: false,
				showHeader: false
			}
        },
        //视频学习页面02
		{
			path: '/learnvideo02',
			name: 'learnvideo02',
			component: () => import('@/pages/learnvideo/LearnVideo02.vue'),
			meta: {
				showFooter: false,
				showHeader: false
			}
		},

		//微信支付
		{
			path: '/wechatpay',
			name: 'wechatpay',
			component: () => import('@/pages/wechatpay/WechatPay.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//学时证明
		{
			path: '/studyingcertificate',
			name: 'studyingcertificate',
			component: () => import('@/pages/studyingcertificate/StudyingCertificate.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		{
			path: '/studyingcertificatehigh',
			name: 'studyingcertificatehigh',
			component: () => import('@/pages/studyingcertificatehigh/StudyingCertificatehigh.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//编辑个人信息
		{
			path: '/editinfo',
			name: 'editinfo',
			component: () => import('@/pages/editinfo/EditInfo.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//空白页
		{
			path: '/blank',
			name: 'blank',
			component: () => import('@/pages/blank/Blank.vue'),
		},
		//暂时性的上传页面
		{
			path: '/fileupload',
			name: 'fileupload',
			component: () => import('@/pages/fileupload/FileUpload.vue'),
		},
		//项目式的店铺主页
		// {
		//   path: '/project',
		//   name: 'project',
		//   component: () => import('@/pages/project/Project.vue'),
		//   meta: {
		//     showFooter: true,
		//     showProHeader: true
		//   }
		// },
		//项目式的店铺主页
		{
			path: '/projectlist',
			name: 'projectlist',
			component: () => import('@/pages/projectlist/ProjectList.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//项目式的课程搜索
		{
			path: '/packagesearch',
			name: 'packagesearch',
			component: () => import('@/pages/packagesearch/PackageSearch.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},

		//项目式的项目首页
		{
			path: '/pojecthomepage',
			name: 'pojecthomepage',
			component: () => import('@/pages/pojecthomepage/pojecthomepage.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//课后习题页面
		{
			path: '/exercise',
			name: 'exercise',
			component: () => import('@/pages/exercise/exercise.vue'),

		},
		// 答疑专区问题详情
		{
			path: '/questiondetail',
			name: 'questiondetail',
			component: () => import('@/pages/questiondetail/QuestionDetail.vue'),
			meta: {
				showHeader: true
			}
		},
		// 辅导员查看学生详情页
		{
			path: '/studentsmessage',
			name: 'studentsmessage',
			component: () => import('@/pages/studentsmessage/StudentsMessage.vue')
		},

		/**项目试用户端 */
		//详情页
		{
			path: '/detailsPage',
			name: 'detailsPage',
			component: () => import('@/pages/detailsPage/detailsPage.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},

		//项目式学习页面
		{
			path: '/lessonstudy',
			name: 'lessonstudy',
			component: () => import('@/pages/lessonstudy/lessonstudy.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},

		//辅导员
		{
			path: '/Instructor',
			name: 'Instructor',
			component: () => import('@/pages/Instructor/Instructor.vue')
		},
		//整体学习页面
		{
			path: '/studyhomepage',
			name: 'studyhomepage',
			component: () => import('@/pages/studyhomepage/StudyHomepage.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},

		//具体学习
		{
			path: '/specificlearn',
			name: 'specificlearn',
			component: () => import('@/pages/specificlearn/specificlearn.vue'),
		},
		//选课中心
		{
			path: '/selectionCenter',
			name: 'selectionCenter',
			component: () => import('@/pages/selectionCenter/selectionCenter.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//文章
		{
			path: '/article',
			name: 'article',
			component: () => import('@/pages/article/article.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//在读课程
		{
			path: '/readingCourse',
			name: 'readingCourse',
			component: () => import('@/pages/reading-course/reading-course.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//已完成课程
		{
			path: '/completedCourse',
			name: 'completedCourse',
			component: () => import('@/pages/completed-course/completed-course.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//旧平台已完成课程
		{
			path: '/completedCourseOld',
			name: 'completedCourseOld',
			component: () => import('@/pages/completed-course-old/completed-course-old.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//z首页证书
		{
			path: '/certificate',
			name: 'certificate',
			component: () => import('@/pages/certificate/certificate.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		// 店铺的后端管理系统
		// 课程云后端登录页面
		{
			path: '/classlogin',
			name: 'classlogin',
			component: () => import('@/pages/classlogin/ClassLogin.vue'),
		},
		{
			//项目式后端管理
			path: '/coursestoremanagement',
			name: 'coursestoremanagement',
			component: () => import('@/pages/coursestoremanagement/CourseStoreManagement.vue'),
			children: [
				// 考卷管理
				{
					path: '/paperManagement',
					name: 'paperManagement',
					component: () => import('@/pages/paper-management/PaperManagement.vue')
				},
				// 课程包管理
				{
					path: '/coursePackageManagement',
					name: 'coursePackageManagement',
					component: () => import('@/pages/course-package-management/CoursePackageManagement.vue')
				},
				// 课程复制
				{
					path: '/courseCopy',
					name: 'courseCopy',
					component: () => import('@/pages/course-copy/CourseCopy.vue')
				},
				// 课件管理
				{
					path: '/coursewareManagement',
					name: 'coursewareManagement',
					component: () => import('@/pages/courseware-management/CoursewareManagement.vue')
				},
				// 试题管理
				{
					path: '/questionManagement',
					name: 'questionManagement',
					component: () => import('@/pages/question-management/QuestionManagement.vue')
				},
				// 课程分类
				{
					path: '/courseClassification',
					name: 'courseClassification',
					component: () => import('@/pages/course-classification/CourseClassification.vue')
				},
				// 课程管理
				{
					path: '/courseManagement',
					name: 'courseManagement',
					component: () => import('@/pages/course-management/CourseManagement.vue')
				},
				// 订单管理
				{
					path: '/orderManagement',
					name: 'orderManagement',
					component: () => import('@/pages/order-management/OrderManagement.vue')
				},
				// 课件学习情况
				{
					path: '/coursewareLearning',
					name: 'coursewareLearning',
					component: () => import('@/pages/courseware-learning/CoursewareLearning.vue')
				},
				// 主网学习情况
				{
					path: '/mainStudySituation',
					name: 'mainStudySituation',
					component: () => import('@/pages/main-study-situation/MainStudySituation.vue')
				},
				// 课程包学习情况
				{
					path: '/categoryStudySituation',
					name: 'categoryStudySituation',
					component: () => import('@/pages/category-study-situation/CategoryStudySituation.vue')
				},
				// 文章管理
				{
					path: '/articleManage',
					name: 'articleManage',
					component: () => import('@/pages/article-manage/ArticleManage.vue')
				},
				// 产品分类
				{
					path: '/productCategory',
					name: 'productCategory',
					component: () => import('@/pages/product_category/ProductCategory.vue')
				},
				// 所有课程
				{
					path: '/allCourses',
					name: 'allCourses',
					component: () => import('@/pages/all_courses/AllCourses.vue')
				},
				// 统计可视化
				{
					path: '/dataVisualization',
					name: 'dataVisualization',
					component: () => import('@/pages/data_visualization/DataVisualization.vue')
				},
				// 统计可视化02
				{
					path: '/dataVisualization02',
					name: 'dataVisualization02',
					component: () => import('@/pages/data_visualization/DataVisualization02.vue')
				},
				// 统计可视化03
				{
					path: '/dataVisualization03',
					name: '/dataVisualization03',
					component: () => import('@/pages/data_visualization/lesson.vue')
				},
				// 取消订单
				{
					path: '/cancelOrder',
					name: 'cancelOrder',
					component: () => import('@/pages/cancelorder/CancelOrder.vue')
				},
				// 通知公告
				{
					path: '/announcements',
					name: 'announcements',
					component: () => import('@/pages/announcements/Announcements.vue')
				},
				// 新闻中心
				{
					path: '/newsCenter',
					name: 'newsCenter',
					component: () => import('@/pages/newscenter/NewsCenter.vue')
				},
				// 标签选用
				{
					path: '/labelsChoose',
					name: 'labelsChoose',
					component: () => import('@/pages/labelschoose/LabelsChoose.vue')
				},
				// 项目包管理2
				{
					path: '/projectpackage',
					name: 'projectpackage',
					component: () => import('@/pages/projectpackage/ProjectPackage.vue')
				},
				//辅导员
				{
					path: '/counsellor',
					name: 'counsellor',
					component: () => import('@/pages/counsellor/Counsellor.vue')
				},
				{
					// 产品管理
					path: '/productlist',
					name: 'productlist',
					component: () => import('@/pages/productlist/ProductList.vue'),
				},
				{
					// 项目式产品管理
					path: '/itemproductlist',
					name: 'itemproductlist',
					component: () => import('@/pages/itemproductlist/ItemProductList.vue'),
				},
				{
					// 轮播图
					path: '/slideshow',
					name: 'slideshow',
					component: () => import('@/pages/slideshow/SlideShow.vue'),
				},
				{
					// 导航栏
					path: '/navigationlist',
					name: 'navigationlist',
					component: () => import('@/pages/navigationlist/Navigationlist.vue'),
				},
				{
					// 板块管理
					path: '/productlist1',
					name: 'productlist1',
					component: () => import('@/pages/productlist1/ProductList1.vue'),
				},
				//项目包管理
				{
					path: '/packagelist',
					name: 'packagelist',
					component: () => import('@/pages/packagelist/packagelist.vue'),
				},
				/**资源管理*/
				// 试题资源
				{
					path: '/exercisestable',
					name: 'exercisestable',
					component: () => import('@/pages/exercisestable/ExercisesTable.vue'),
				},
				// 测试模块
				{
					path: '/exercisestable_test',
					name: 'exercisestable_test',
					component: () => import('@/pages/exercisestable_test/ExercisesTableTest.vue'),
				},
				// 音频资源
				{
					path: '/audiotable',
					name: 'audiotable',
					component: () => import('@/pages/audiotable/AudioTable.vue'),
				},
				// 文档资源
				{
					path: '/doctable',
					name: 'doctable',
					component: () => import('@/pages/doctable/DocTable.vue'),
				},
				// 图片资源
				{
					path: '/imagetable',
					name: 'imagetable',
					component: () => import('@/pages/imagetable/ImageTable.vue'),
				},
				// 视频资源
				{
					path: '/videotable',
					name: 'videotable',
					component: () => import('@/pages/videotable/VideoTable.vue'),
				},
				// 讨论资源
				{
					path: '/discusstable',
					name: 'discusstable',
					component: () => import('@/pages/discusstable/DiscussTable.vue'),
				},
				// 课后习题资源（都是简答题）
				{
					path: '/afterclasstable',
					name: 'afterclasstable',
					component: () => import('@/pages/afterclasstable/AfterClassTable.vue'),
				},
				{
					path: '/activity',
					name: 'activity',
					component: () => import('@/pages/activity/Activity.vue')
				},
				//任务管理
				{
					path: '/task',
					name: 'task',
					component: () => import('@/pages/task/Task.vue')
				},
				//订单管理
				//whole 全部订单页面  
				{
					path: '/orders',
					name: 'orders',
					component: () => import('@/pages/orders/Orders.vue')
				},
				//发票管理
				{
					path: '/invoice',
					name: 'invoice',
					component: () => import('@/pages/invoice/Invoice.vue')
				},
				// 导出购买记录
				{
					path: '/purchaseRecord',
					name: 'purchaseRecord',
					component: () => import('@/pages/purchaseRecords/PurchaeRecords.vue')
				},
				//项目
				{
					path: '/xianmu',
					name: 'xianmu',
					component: () => import('@/pages/xianmu/item.vue')
				},
				// 项目分数百分百设置
				{
					path: '/percentage',
					name: 'percentage',
					component: () => import('@/pages/percentage/percentage.vue')
				},
				// 班级管理
				{
					path: '/classmanagement',
					name: 'classmanagement',
					component: () => import('@/pages/classmanagement/banji.vue')
				},
				// 学生管理
				{
					path: '/stumanage',
					name: 'stumanage',
					component: () => import('@/pages/stumanage/StuManage.vue')
				},
				// 余额存取记录
				{
					path: '/balanceLog',
					name: 'balanceLog',
					component: () => import('@/pages/balanceLog/BalanceLog.vue')
				},
				// cz管理
				{
					path: '/stuczmanae',
					name: 'stuczmanae',
					component: () => import('@/pages/stuczmanae/StuCZManage.vue')
				},
				// 学时证明管理
				{
					path: '/stuprovemanage',
					name: 'stuprovemanage',
					component: () => import('@/pages/stuprovemanage/StuProveManage.vue')
				},
				//学生批量注册
				{
					path: '/sturegister',
					name: '/sturegister',
					component: () => import('@/pages/sturegister/StuRegister.vue')
				},
				//学生批量选课
				{
					path: '/stuselectclass',
					name: '/stuselectclass',
					component: () => import('@/pages/stuselectclass/StuSelectClass.vue')
				},
				//学生批量开课
				{
					path: '/stuopenclass',
					name: '/stuopenclass',
					component: () => import('@/pages/stuopenclass/StuOpenClass.vue')
				},
				//学生批量设置年度
				{
					path: '/stusetyear',
					name: '/stusetyear',
					component: () => import('@/pages/stusetyear/StuSetYear.vue')
				},
				//余额充值
				{
					path: '/overage',
					name: '/overage',
					component: () => import('@/pages/overage/overage.vue')
				},
				//标签管理
				{
					path: '/labelmanagement',
					name: 'labelmanagement',
					component: () => import('@/pages/labelmanagement/LabelManagement.vue'),
				},
				//评分占比
				{
					path: '/percentage',
					name: 'percentage',
					component: () => import('@/pages/percentage/percentage.vue'),
				},
				//学习情况
				{
					path: '/studySituation',
					name: 'studySituation',
					component: () => import('@/pages/studySituation/studySituation.vue'),
				},
				//考试结果查看
				{
					path: '/testResults',
					name: 'testResults',
					component: () => import('@/pages/testResults/testResults.vue'),
				},
				//课程年度修改日志
				{
					path: '/course-year-change-log',
					name: 'course-year-change-log',
					component: () => import('@/pages/course-year-change-log/course-year-change-log.vue'),
				},
				//学时证明批量生成
				{
					path: '/batch-generate-prove',
					name: 'batch-generate-prove',
					component: () => import('@/pages/batch-generate-prove/batch-generate-prove.vue'),
				},
				// 后台用户管理
				{
					path: '/backgroundUserManagement',
					name: 'backgroundUserManagement',
					component: () => import('@/pages/background_user_management/BackgroundUserManagement.vue')
				},
			]

		},
		{
			path: '/allocation',
			name: 'allocation',
			component: () => import('@/pages/xianmu/allocation.vue'),
		},
		//添加班级
		{
			path: '/addbanji',
			name: 'addbanji',
			component: () => import('@/pages/classmanagement/addbanji.vue'),
		},
		//成员配置
		{
			path: '/banjiall',
			name: 'banjiall',
			component: () => import('@/pages/classmanagement/banjiall.vue'),
		},
		//班级编辑
		{
			path: '/banjiupdate',
			name: 'banjiupdate',
			component: () => import('@/pages/classmanagement/banjiupdate.vue'),
		},
		// 项目通知
		{
			path: '/projectnews',
			name: 'projectnews',
			component: () => import('@/pages/projectnews/ProjectNews.vue'),
			meta: {
				showFooter: true,
				showHeader: true
			}
		},
		//数据统计
		{
			path: '/showdata',
			name: 'showdata',
			component: () => import('@/pages/showdata/ShowData.vue')
		},
		// 权限管理登录
		{
			path: '/authority_management_login',
			name: 'authority_management_login',
			component: () => import('@/pages/authority_management_login/AuthorityManagementLogin.vue')
		}

	]
})
//全局守卫
router.beforeEach((to, from, next) => {
	let model = document.querySelector('#modal-center');

	if (sessionStorage.getItem('authid')) {
		store.state.authority_management = sessionStorage.getItem('authid')
	}

	if (to.path === '/authority_management_login') {
		next()
		return
	} else if (to.matched[0] !== undefined) {
		if (to.matched[0].path === '/coursestoremanagement') {
			if (sessionStorage.getItem('authid')) {
				next()
				return
			} else {
				next({
					path: '/'
				})
			}
		}
	}
	//如果不是店铺管理员进入就跳回首页
	// if (to.matched[0].path === '/coursestoremanagement') {
	//     if (sessionStorage.getItem('tpshopid') != '' && sessionStorage.getItem('tpshopid') != 'undefined' && sessionStorage.getItem('tpshopid') != 'null') {
	//         next();
	//     } else {
	//         next({
	//             path: '/'
	//         });
	//     }
	// }
	if (to.path === '/' || to.path === '/classsearch' || to.path === '/classdetails' || to.path === '/detailsPage' || to
		.path === '/blank' || to.path === '/forgetpassword' || to.path === '/test' || to.path === '/classlogin' || to.path ===
		'/project' || to.path === '/pojecthomepage' || to.path === '/projectlist' || to.path === '/packagesearch' || to.path ===
		'/showdata' || to.path === '/selectionCenter' || to.path === '/article' || to.path === '/rechargeBalance') {
		next();
	} else if (sessionStorage.getItem('tpid') || store.state.id || sessionStorage.getItem('instructor') || store.state.instructor) {
		next();
	} else if (model !== null) {
		UIkit.modal(model).show();
	} else {
		next({
			path: '/'
		});
	}
});
export default router;
